import React, { useState, useContext } from 'react'
import { Grid, Form, Header, Icon, Button, Radio, Segment } from 'semantic-ui-react'
import NewPerformanceEvaluationPageContext from './IvrTrackingPageContext'
import FoTrackingPageContext from './FoTrackingPageContext'
import DateTimePicker from '../../app/DateTimePicker'
import constants from '../../../common/constants'

function NewFilterFO() {
  const ctx = useContext(FoTrackingPageContext)
  const [isExpanded, setIsExpanded] = useState(false)
  let [clientVisible, setClientVisible] = useState(false)
  let [userVisible, setUserVisible] = useState(false)
  let [userRoleCheck, setUserRoleCheck] = useState('')
  let [evaluationType, setEvaluationType] = useState('')
  let [evaluateByCloseDate, setEvaluateByCloseDate] = useState(false)
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Header as="h4">
          Filter
          <Header.Subheader>
            - <strong>From</strong> and <strong>To</strong> Filters are required for IVR Evaluation to take effect.
            <br />- IVR Evaluation will begin once you enter the required filters or change any filter.
          </Header.Subheader>
        </Header>
        <Icon name="arrow alternate circle down outline" size="large" onClick={() => setIsExpanded(!isExpanded)} />
      </div>
      <Grid columns={5}>
        <Grid.Row>
          {/* <Grid.Column>
            <Segment compact>
              <Radio
                toggle
                label={'Evaluation From Closed Date'}
                onChange={() => {
                  ctx.newfilters.setEvaluationByClosedDate(!ctx.newfilters.evaluationByClosedDate)
                }}
              />
            </Segment>
          </Grid.Column> */}
          <Grid.Column>
            <Form.Input label="From Date">
              <DateTimePicker placeholder="Select From Date" type="date" value={ctx.newfilters.from} onChange={ctx.newfilters.setFrom} />
            </Form.Input>
          </Grid.Column>
          <Grid.Column>
            <Form.Input label="To Date">
              <DateTimePicker placeholder="Select To Date" type="date" value={ctx.newfilters.to} onChange={ctx.newfilters.setTo} />
            </Form.Input>
          </Grid.Column>
          <Grid.Column>
            <Form.Dropdown
              label="Evaluation Type"
              search
              selection
              placeholder="Select type"
              options={[
                { key: 'user', text: 'User', value: 'user' },
                { key: 'investigator', text: 'All Investigator', value: 'Investigator' },
                // { key: 'team_lead', text: 'Team Lead', value: 'Team Lead' },

              ]}
              value={evaluationType}
              onChange={(_, { value }) => {
                setEvaluationType(value as string)
                if (value == 'user') {
                  setUserVisible(true)
                  setClientVisible(false)
                }  else if (value == 'Investigator') {
                  ctx.newfilters.setViewType('Investigator')
                } 
                // else if (value == 'Team Lead') {
                //   ctx.filters.setViewType('team_lead')
                // } 
                else {
                  setClientVisible(false)
                  setUserVisible(false)
                }
              }}
            />
          </Grid.Column>
          {clientVisible && (
            <Grid.Column>
              <Form.Dropdown
                label="Client"
                search
                selection
                placeholder="Select Client"
                options={ctx.options.client}
                value={ctx.newfilters.client}
                onChange={(_, { value }) => {
                  ctx.newfilters.setClient(value as string)
                  ctx.newfilters.setViewType('client')
                }}
              />
            </Grid.Column>
          )}
          {userVisible && (
            <>
              <Grid.Column>
              <Form.Dropdown
              label="User Role"
              search
              selection
              placeholder="Select User Role"
              options={
                evaluationType === "user"
                  ? ctx.options.userRoles.filter((r) => r.value === "Investigator")
                  : ctx.options.userRoles
              }
              value={ctx.newfilters.userRole}
              onChange={(_, { value }) => {
                ctx.newfilters.setUserRole(value as string);
                setUserRoleCheck(value as string);
              }}
            />

              </Grid.Column>
              <Grid.Column>
                <Form.Dropdown
                  label="User"
                  search
                  selection
                  placeholder="Select User"
                  options={ctx.options.user}
                  value={ctx.newfilters.user}
                  onChange={(_, { value }) => {
                    ctx.newfilters.setUser(value as string)
                    if (userRoleCheck == constants.roleTitle.investigator) {
                      ctx.newfilters.setViewType('user')
                    } else {
                      ctx.newfilters.setViewType('user')
                    }
                  }}
                />
              </Grid.Column>
            </>
          )}

          {/* <Grid.Column>{!isExpanded && <Button onClick={clearAllFilters}>Clear</Button>}</Grid.Column> */}
        </Grid.Row>
      </Grid>
      {isExpanded && (
        <Grid columns={5}>
          <Grid.Row></Grid.Row>
          <Grid.Row>
            {!clientVisible && (
              <Grid.Column>
                <Form.Dropdown
                  label="Client"
                  search
                  selection
                  placeholder="Select Client"
                  options={ctx.options.client}
                  value={ctx.newfilters.client}
                  onChange={(_, { value }) => ctx.newfilters.setClient(value as string)}
                />
              </Grid.Column>
            )}
            {!userVisible && (
              <>
                <Grid.Column>
                  <Form.Dropdown
                    label="User Role"
                    search
                    selection
                    placeholder="Select User Role"
                    options={ctx.options.userRoles}
                    value={ctx.newfilters.userRole}
                    onChange={(_, { value }) => ctx.newfilters.setUserRole(value as string)}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Form.Dropdown
                    label="User"
                    search
                    selection
                    placeholder="Select User"
                    options={ctx.options.user}
                    value={ctx.newfilters.user}
                    onChange={(_, { value }) => ctx.newfilters.setUser(value as string)}
                  />
                </Grid.Column>
              </>
            )}
            <Grid.Column>
              <Form.Dropdown
                label="District"
                search
                selection
                placeholder="Select District"
                options={ctx.options.districts}
                value={ctx.newfilters.district}
                onChange={(_, { value }) => ctx.newfilters.setDistrict(value as string)}
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Dropdown
                label="Case Category"
                search
                selection
                placeholder="Select Case Category"
                options={ctx.options.category}
                value={ctx.newfilters.category}
                onChange={(_, { value }) => ctx.newfilters.setCategory(value as string)}
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Dropdown
                search
                selection
                label="Hospital"
                placeholder="Select Hospital"
                options={ctx.options.hospital}
                value={ctx.newfilters.hospital}
                onChange={(_, { value }) => ctx.newfilters.setHospital(value as string)}
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Input label="Search" placeholder="Enter Text..." value={ctx.newfilters.search} onChange={(_, { value }) => ctx.newfilters.setSearch(value)} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Button onClick={clearAllnewfilters}>Clear</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )}
    </>
  )

  function clearAllnewfilters() {
    ctx.newfilters.setUserRole('')
    ctx.newfilters.setUser('')
    ctx.newfilters.setCategory('')
    ctx.newfilters.setClient('')
    ctx.newfilters.setDistrict('')
    ctx.newfilters.setHospital('')
    ctx.newfilters.setFrom('')
    ctx.newfilters.setTo('')
    ctx.newfilters.setSearch('')
    ctx.newfilters.setViewType('')
    ctx.newfilters.setEvaluationByClosedDate(false)
    setUserVisible(false)
    setClientVisible(false)
  }
}

export default NewFilterFO
